import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
import BaseLayout from '@/views/layout/BaseLayout'
// import AdminLayout from '@/views/adminLayout/AdminLayout'
import personRoutes from './person'
import selfPlatformRoutes from './self_platform'
import { i18n } from '@/i18n'
import { cloneDeep, isUndefined } from 'lodash-es'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

// 判断是否是AI音频发布平台
export const isAIPublish = window.location.pathname.includes('ai_publish')

// 过滤出meta.authCheck为true的路由
export function filterAuthRoutes(routes) {
  const res = []
  routes.forEach(route => {
    const cloneRoute = cloneDeep(route)
    const authCheck = cloneRoute.meta && cloneRoute.meta.authCheck
    if (isUndefined(authCheck) || authCheck || (typeof authCheck === 'function' && authCheck())) {
      res.push(cloneRoute)
    }

    if (cloneRoute.children && cloneRoute.children.length) {
      cloneRoute.children = filterAuthRoutes(cloneRoute.children)
    }
  })
  return res
}

export const getRoutes = () => [
  {
    path: '/',
    name: 'default',
    redirect: '/index',
    isShow() {
      return false
    },
    component: BaseLayout,
    children: [
      {
        path: '/index',
        name: 'homePage',
        isShow() {
          return false
        },
        component: () => import(/* webpackChunkName: "homePage" */ '@/views/home/index'),
        meta: { title: i18n.t('header.home') },
      },
      {
        path: '/ai_publish/index',
        name: 'aIPublishHomePage',
        component: () => import(/* webpackChunkName: "aIPublishHomePage" */ '@/views/home/aiPublish/index'),
        meta: { title: i18n.t('header.home') },
      },

      ...(isAIPublish ? [] : selfPlatformRoutes()),
    ]
  },
  {
    path: '/404',
    name: 'notExist',
    isShow() {
      return false
    },
    component: () => import(/* webpackChunkName: "notExist" */ '@/views/404'),
    meta: { title: '无法访问' },
    hidden: true
  }
]

export let router = null

export const personAllRoutes = personRoutes(Layout)

Router.prototype.open = function(routeObject) {
  const { href } = this.resolve(routeObject)
  window.open(href, '_blank')
}

export default function initRouter() {
  const rt = new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
      if (to.hash) {
        return savedPosition
      }
      return { y: 0 }
    },
    routes: getRoutes()
  })
  router = rt

  return rt
}
